import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { RitualsState } from '@/store/rituals/types';

export const getters: GetterTree<RitualsState, RootState> = {};
